const paymentMethodsES = {
    "view": {
        "table": {
            "title": "Tu lista de métodos de pago",
            "column": {
                "cardholder_name": "Nombre del titular",
                "card_number": "Número de tarjeta",
                "expiry_month": "Mes de expiración",
                "expiry_year": "Año de expiración",
                "type": "Tipo",
                "status": "Estado",
                "action": "Acción"
            },
            "label": {
                "is_default": "Predeterminado",
                "is_secondary": "Secundario",
                "is_valid": "Válido",
                "is_expired": "Expirado",
                "not_available": "No disponible",
                "month_january": "Enero",
                "month_february": "Febrero",
                "month_march": "Marzo",
                "month_april": "Abril",
                "month_may": "Mayo",
                "month_june": "Junio",
                "month_july": "Julio",
                "month_august": "Agosto",
                "month_september": "Septiembre",
                "month_october": "Octubre",
                "month_november": "Noviembre",
                "month_december": "Diciembre"
            },
            "dropdown": {
                "action": "Acción",
                "edit": "Editar",
                "delete": "Eliminar"
            }
        },
        "message": {
            "maxPaymentMethodsLimitReached": "Has alcanzado el límite de 3 métodos de pago. Si deseas agregar un nuevo pago, puedes hacerlo eliminando uno existente.",
            "success": "¡El método de pago ha sido eliminado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "delete": {
                "header": "Eliminar método de pago {{cardNumber}}",
                "body": "¿Estás seguro de que deseas eliminar este método de pago?"
            }
        }
    },
    "add": {
        "title": "Agregar método de pago",
        "form": {
            "label": {
                "card_details": "Detalles de la tarjeta",
                "cardholder_name": "Nombre del titular",
                "card_number": "Número de tarjeta",
                "expiry_month": "Mes de expiración",
                "expiry_year": "Año de expiración (AAAA)",
                "security_code_cvc": "Código de seguridad (CVC)",
                "billing_details": "Detalles de facturación",
                "country": "País",
                "street_and_number": "Calle y número",
                "city": "Ciudad",
                "postal_code": "Código postal"
            },
            "help_text": {
                "security_code_cvc": "El código de seguridad (CVC) de tu tarjeta es el número de 3 o 4 dígitos ubicado en la parte posterior de la mayoría de las tarjetas."
            },
            "options": {
                "month": {
                    "january": "Enero",
                    "february": "Febrero",
                    "march": "Marzo",
                    "april": "Abril",
                    "may": "Mayo",
                    "june": "Junio",
                    "july": "Julio",
                    "august": "Agosto",
                    "september": "Septiembre",
                    "october": "Octubre",
                    "november": "Noviembre",
                    "december": "Diciembre"
                },
                "expiry_month": {
                    "select": "Seleccionar mes de expiración"
                },
                "country": {
                    "select": "Seleccionar país"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "expiry_month_required": "El mes de expiración es obligatorio",
                "expiry_month_valid": "El mes de expiración no debe estar en el pasado",
                "country_required": "El país es obligatorio"
            }
        },
        "message": {
            "success": "¡El método de pago ha sido agregado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "addPaymentMethod": {
                "header": "¿Estás seguro de que deseas agregar este método de pago a tu perfil?",
                "body": "Por la presente garantizas que todos los datos proporcionados son veraces. Eres el único y legalmente responsable de los datos proporcionados y de la veracidad de dicha información.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    },
    "update": {
        "title": "Actualizar método de pago",
        "form": {
            "label": {
                "card_details": "Detalles de la tarjeta",
                "cardholder_name": "Nombre del titular",
                "card_number": "Número de tarjeta",
                "expiry_month": "Mes de expiración",
                "expiry_year": "Año de expiración (AAAA)",
                "security_code_cvc": "Código de seguridad (CVC)",
                "billing_details": "Detalles de facturación",
                "country": "País",
                "street_and_number": "Calle y número",
                "city": "Ciudad",
                "postal_code": "Código postal",
                "set_as_default": "Establecer como predeterminado"
            },
            "help_text": {
                "security_code_cvc": "El código de seguridad (CVC) de tu tarjeta es el número de 3 o 4 dígitos ubicado en la parte posterior de la mayoría de las tarjetas."
            },
            "options": {
                "month": {
                    "january": "Enero",
                    "february": "Febrero",
                    "march": "Marzo",
                    "april": "Abril",
                    "may": "Mayo",
                    "june": "Junio",
                    "july": "Julio",
                    "august": "Agosto",
                    "september": "Septiembre",
                    "october": "Octubre",
                    "november": "Noviembre",
                    "december": "Diciembre"
                },
                "expiry_month": {
                    "select": "Seleccionar mes de expiración"
                },
                "country": {
                    "select": "Seleccionar país"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "validation": {
                "expiry_month_required": "El mes de expiración es obligatorio",
                "expiry_month_valid": "El mes de expiración no debe estar en el pasado",
                "country_required": "El país es obligatorio"
            }
        },
        "message": {
            "success": "¡El método de pago ha sido actualizado!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        },
        "modal": {
            "updatePaymentMethod": {
                "header": "¿Estás seguro de que deseas actualizar tu método de pago?",
                "body": "Por la presente garantizas que todos los datos proporcionados son veraces. Eres el único y legalmente responsable de los datos proporcionados y de la veracidad de dicha información.",
                "button": {
                    "cancel": "Cancelar",
                    "confirm": "Confirmar"
                }
            }
        }
    }
};

export default paymentMethodsES;